import canUseDOM from './canUseDOM'

/** Strip any trailing slash(es) so callers can safely append a path. */
const stripTrailingSlash = (url: string) => url.replace(/\/+$/, '')

/**
 * Canonical absolute base URL for server-rendered output: page metadata,
 * robots.txt, sitemap, JSON-LD schema and in-email links. Precedence:
 *   1. NEXT_PUBLIC_SERVER_URL              — explicit, set per environment
 *   2. https://VERCEL_PROJECT_PRODUCTION_URL — Vercel production/custom domain (bare host)
 *   3. http://localhost:3000               — local development
 */
export const getServerSideURL = () => {
  const base =
    process.env.NEXT_PUBLIC_SERVER_URL ||
    (process.env.VERCEL_PROJECT_PRODUCTION_URL
      ? `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
      : 'http://localhost:3000')

  return stripTrailingSlash(base)
}

export const getClientSideURL = () => {
  if (canUseDOM) {
    const protocol = window.location.protocol
    const domain = window.location.hostname
    const port = window.location.port

    return `${protocol}//${domain}${port ? `:${port}` : ''}`
  }

  // Server-side render: reuse the canonical base so absolute URLs stay
  // consistent with getServerSideURL (same precedence, scheme-correct).
  return getServerSideURL()
}
